import { Suspense, lazy } from "react";

const GlobalCoverageMapInner = lazy(() => import("./GlobalCoverageMapInner"));

const GlobalCoverageMap = () => (
  <Suspense fallback={null}>
    <GlobalCoverageMapInner />
  </Suspense>
);

export default GlobalCoverageMap;
